import React, { Component } from 'react';
import {
  Button,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
  Link
} from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import i18n from '../../i18n';
import '../../assets/stylesheets/Closet.css';
import {
  imagePaddingString
} from '../../constants/general';
import RequireFeatureFlag from '../RequireFeatureFlag';
import closetCartSlice from '../../collections/closetCart';

class ProductDetailsModal extends Component {

  requestItemHandler = (product, size) => {
    const { addCartItem } = this.props;
    return ()=>{
      addCartItem({product, size})
    }
  }

  addSizes = (product) => {
    const { cartItems, openCart } = this.props;
    return product.sizes.map((size) => {
      const inCart = cartItems.find(match => match.productId === product.id && match.sizeId === size.id );
      const qtyInCart = inCart ? inCart.qty : 0
      const binLocation = size.bin_locations.map((bin) => {return bin.label; }).join(' ')
      const disabled = !size.bin_locations || size.bin_locations?.reduce((a, b) => a.quantity + b.quantity, 0) === 0;
      return (
        <Grid container className="sizeGrid" key={size.sku} alignContent="center">
          <Grid item xs={2}>
            <Typography variant="body1">
              {size.name}
            </Typography>
          </Grid>
          {size.bin_locations &&
            <Grid item xs={2} className='closetBinLocation binLocation'>
              <Typography variant="body1">
                {binLocation}
              </Typography>
            </Grid>
          }
          <RequireFeatureFlag feature="isClosetCartEnabled">
            <Grid item xs={5}>
              <Button
                onClick={this.requestItemHandler(product,size)}
                className="ssenseButton ssensePrimary itemButton"
                disabled={disabled}
              >
                {disabled ? i18n.t('closet:unavailable') : i18n.t('closet:addRequest')}
              </Button>
            </Grid>
            <Grid item xs={3}>
              { inCart ? (
                <Button onClick={openCart}>
                  <Typography variant="body1">
                    {i18n.t('closet:inYourCart', { nb: qtyInCart })}
                  </Typography>
                </Button>
              ) : '' }
            </Grid>
          </RequireFeatureFlag>
        </Grid>
      );
    });
  }

  render() {
    const { product, showModal, onClose } = this.props;

    if (!product) {
      return null;
    }

    return (
      <Dialog 
        open={showModal}
        onClose={onClose}
        scroll='paper'
      >
        <DialogTitle disableTypography className="dialogTitle">
          <Grid container>
            <Grid item xs={11}>
              <Typography variant="body1">{`${product.brand[0]?.name}: ${product.name}`}</Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton aria-label="close" onClick={onClose}>
                <CloseIcon className="closeIcon" />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid
            className="productDetailsModal"
            container
            direction="column"
            justify="center"
          >
            <Grid item xs={12} className="gridItem imageWidth">
              <img
                src={
                  product.images[0]?.image?.replace('__IMAGE_PARAMS__', imagePaddingString)
                }
                alt={product.name} 
              />
            </Grid>
            <Grid item xs={12} className="gridItem">
              <Typography variant="body1">
                {`${i18n.t('closet:productCode')}: ${product.sku}`}
              </Typography>
            </Grid>
            <Grid item xs={12} className="gridItem">
              <Link 
                className="ssenseLink"
                target="_blank"
                href={product.weblink}
              >
                {product.weblink}
              </Link>
            </Grid>
            <Grid item xs={12} className="gridItem">
              <Typography variant="body1">
                {`${i18n.t('closet:sizes')}:`}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {this.addSizes(product)}           
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            className="ssenseButton ssenseDefault"
          >
            {i18n.t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = { addCartItem: closetCartSlice.actions.addItem };

const mapStateToProps = state => ({
  cartItems: state.closetCart.items,
});

ProductDetailsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  product: PropTypes.shape({
    name: PropTypes.string,
    brand: PropTypes.arrayOf(PropTypes.object),
    weblink: PropTypes.string,
    sku: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.object),
    sizes: PropTypes.arrayOf(PropTypes.object)
  }),
  addCartItem: PropTypes.func.isRequired,
  openCart: PropTypes.func.isRequired,
  cartItems: PropTypes.arrayOf(PropTypes.object)
}

ProductDetailsModal.defaultProps = {
  product: null,
  cartItems: []
}


export { ProductDetailsModal as ProductDetailsModalNoConnect }
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailsModal);

